import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import i18next from 'i18next';
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";

export const BottomButtons = () => {
    return (
        <>
            <div className="bottom-buttons">
                <div className="position-fixed bottom-0 start-0 mb-5 ms-sm-5">
                    <LanguageSelector />
                </div>
                <a href="https://github.com/begonufer" alt="Github" className="btn bottom-button text-white p-3 fw-bold" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGithub} size="3x" />
                </a>
                <a href="https://www.linkedin.com/in/begonufer/" alt="LinkedIn" className="btn bottom-button text-white p-3 fw-bold" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} size="3x" />
                </a>
                <a href="https://drive.google.com/file/d/18MX5ilwJmaszDL2Jz5gs7ohznMcnZyAu/view?usp=sharing" download="Begoña-Núñez-Fernández-CV.pdf" className="btn bottom-button text-white download-button pt-sm-3 px-sm-5 fw-bold" target="_blank" rel="noreferrer">
                    {window.innerWidth <= 768 ? <FontAwesomeIcon icon={faCloudArrowDown} size="3x" /> : <h1>{i18next.t('download')}</h1>}
                </a>
            </div>
        </>
    );
};


const LanguageSelector = () => {
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage') || 'en');
  
    const changeLanguage = (lang) => {
        i18next.changeLanguage(lang);
        localStorage.setItem('selectedLanguage', lang);
        setSelectedLanguage(lang);
        window.location.reload();
    };
  
    useEffect(() => {
        const checkbox = document.getElementById('flexSwitchCheckDefault');
        checkbox.checked = selectedLanguage === 'es';
        checkbox.setAttribute('aria-checked', selectedLanguage === 'es');
    }, [selectedLanguage]);
  
    return (
        <div className="form-check form-switch language-switch">
                <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    checked={selectedLanguage === 'es'} 
                    onChange={() => changeLanguage(selectedLanguage === 'es' ? 'en' : 'es')}
                    aria-checked={selectedLanguage === 'es'} 
                />
                <label className="form-check-label" htmlFor="flexSwitchCheckDefault"></label>
        </div>
    );
};